/** @file Euclidean length of a vector. */
import type { Vec3 } from './vec3';

/** `|v|`. */
export function vec3Length(v: Vec3): number {
  return Math.hypot(v[0], v[1], v[2]);
}
